<ion-avatar>
  <img [src]="url" *ngIf="url">
</ion-avatar>
